import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  TextField,
  Select,
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Checkbox,
  Collapse,
  FormControl,
  MenuItem,
  InputLabel,
  RadioGroup,
  Radio,
  FormHelperText,
} from '@material-ui/core';
import { isEmpty, get } from 'lodash';
import messages from 'containers/PreOpeningPage/messages';
import { translate, arrayTranslate } from 'containers/services/translate';
import styled from 'styled-components';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  DRIVER,
  EMPTY_DRIVER,
  CLAIM,
  EMPTY_CLAIM,
  LISTINGS,
  CLAIM_STATUS,
} from 'containers/data-structure';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment-timezone';
import ClaimDeclarationDrawer from 'containers/RecapManagerPage/ClaimDeclarationDrawer';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import { shouldDisplayEditButtonClaim } from 'containers/RecapManagerPage/utils';
import validate from 'containers/services/validateForm';
import { displayErrorText } from 'containers/services/validateForm';
import {
  dateStringToLocalDate,
  filterNotRcClaims,
} from 'containers/IdentificationPage/utils';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';

export const claimDeclarationConstraints = (driver: any) => {
  return {
    [DRIVER.IS_DRIVER_THE_INSURED]: {
      presence: true,
    },
    [DRIVER.LAST_NAME]: {
      presence: get(driver, [DRIVER.IS_DRIVER_THE_INSURED], '') === CHOICE.NO,
    },
    [DRIVER.FIRST_NAME]: {
      presence: get(driver, [DRIVER.IS_DRIVER_THE_INSURED], '') === CHOICE.NO,
    },
    [DRIVER.CIN]: {
      presence: get(driver, [DRIVER.IS_DRIVER_THE_INSURED], '') === CHOICE.NO,
      format: {
        pattern: /[A-Za-z]{1,2}\d{1,6}[A-Za-z]?|\d{1,7}[A-Za-z]/,
        message: messages.cinInvalid,
      },
    },
    [DRIVER.DATE_OF_BIRTH]: {
      format: {
        pattern: /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i,
        message: messages.invalidDate,
      },
    },
    [DRIVER.LICENSE_START_DATE]: {
      format: {
        pattern: /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i,
        message: messages.invalidDate,
      },
    },
    [DRIVER.SEX]: {
      presence: get(driver, [DRIVER.IS_DRIVER_THE_INSURED], '') === CHOICE.NO,
    },
    [DRIVER.DATE_OF_BIRTH]: {
      format: {
        pattern: /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i,
        message: messages.invalidDate,
      },
    },
    [DRIVER.LICENSE_START_DATE]: {
      format: {
        pattern: /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i,
        message: messages.invalidDate,
      },
    },
  };
};

export const claimDeclarationValidator = (driver: any) => {
  if (get(driver, [DRIVER.IS_DRIVER_THE_INSURED], '') === CHOICE.YES) {
    return validate(driver, {
      ...claimDeclarationConstraints(driver),
      [DRIVER.CIN]: {
        presence: false,
      },
    });
  }
  return validate(driver, claimDeclarationConstraints(driver));
};

const Container = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .title {
    text-align: left;
    text-transform: inherit;
    font-size: 18px;
    letter-spacing: 0;
    margin-left: 10px;
    margin-bottom: 10px;
    color: #374065;
    display: inline;
    font-weight: 500;
    font-family: Roboto;
  }
  .subContainer {
    display: flex;
    justify-content: space-around;
    margin-top: 25px;
  }
  .input {
    width: 23%;
    margin-bottom: 33px;
    font-size: 13px;
  }
  .checkdiv {
    align-items: center;
    display: flex;
    margin-left: 10px;
  }
  .text {
    text-align: left;
    font-size: 15px;
    margin-right: 17px;
    color: #374065;
    font-weight: Bold;
    font-family: Roboto;
  }
  .cardContent {
    padding-bottom: 0px;
    margin-bottom: 16px;
  }
  .label-input {
    font-size: 13px;
  }
  .MuiFormLabel-root {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
  .subContainerSP {
    padding-left: 10px;
  }
  .MuiInputLabel-shrink {
    font-size: 20px;
    color: #666;
  }
`;

export const Title = styled(Typography)`
  text-align: left;
  font-size: 24px;
  letter-spacing: 0;
  margin-left: 10px;
  margin-bottom: 40px;
  margin-top: 20px;
  color: #2b2727;
  font-weight: 500;
  font-family: Roboto;
`;

export interface ClaimDeclarationProps {
  intl: IntlShape;
  updateFilde?: Function;
  claimToPreopen: any;
  inputProps?: any;
  disableInput?: boolean;
  inputLabelProps?: boolean;
  policyInfo?: {};
  listings?: Listings;
  storedClaimToPreopen?: any;
  setClaimRecap?: Function;
  claimDeclarationValidation?: any;
  isRecapPage: boolean;
  isManager: boolean;
  isReadOnly: boolean;
  selectedClaim?: any;
  isLawyer?: boolean;
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  isCourtManager?: boolean;
  isOpeningManager?: boolean;
  isOnlyForRead?: boolean;
  requestClaimRecap?: Function;
  isBasicManagement?: boolean;
  location?: any;
}

const StyledTextField = styled(TextField)`
  .MuiInputBase-input.Mui-disabled {
    font-weight: 500;
  }
`;

const ClaimInformation: React.FC<ClaimDeclarationProps> = (
  props,
): JSX.Element => {
  const isRejected =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.REJECTED;
  const isValidated =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.VALIDATED;
  const isValidatedCorpo =
    get(props.storedClaimToPreopen, 'claim.status') ===
    CLAIM_STATUS.PENDING_APPROVAL;
  useEffect(() => {
    if (!props.isBasicManagement) {
      const state = !isEmpty(props.storedClaimToPreopen)
        ? { ...props.storedClaimToPreopen }
        : { ...props.claimToPreopen };

      if (!isEmpty(state.driver)) {
        updateClaimDriver(state.driver);
      }
    }
  }, [props.claimToPreopen, props.storedClaimToPreopen]);
  useEffect(() => {
    if (!props.isBasicManagement) {
      const state = { ...props.claimToPreopen };
      let opposingPartySagis = [];
      const riskSagis = get(
        filterNotRcClaims(props.policyInfo, props.listings),
        `sagis.claims[${props.selectedClaim}].offeredRisks`,
        [],
      ).find((el: any) => el.riskName === RISK_NAME.MATERIEL);
      if (riskSagis) opposingPartySagis = get(riskSagis, 'opposingParties');
      if (isEmpty(state.driver)) {
        state.driver = { ...EMPTY_DRIVER };
        if (!isEmpty(get(props.policyInfo, 'sagis.claims'))) {
          if (!isEmpty(opposingPartySagis)) {
            state.opposingParty.hasMaterialDammage = 'YES';
            state.opposingParty.vehicules = opposingPartySagis.map(
              (opposingParty: any) => {
                return {
                  firstName: get(opposingParty, `firstName`),
                  lastName: get(opposingParty, `lastName`),
                  brand: '',
                  opposingParty: get(opposingParty, `insuranceCompanyCode`),
                  registrationNumber: get(opposingParty, `registrationNumber`),
                };
              },
            );
            state.claim = {
              ...EMPTY_CLAIM,
              [CLAIM.CLAIM_NUMBER]: get(
                filterNotRcClaims(props.policyInfo, props.listings),
                `sagis.claims[${props.selectedClaim}].code`,
              ),
              [CLAIM.FIRST_NAME]: get(
                props.policyInfo,
                'sagis.policy.clientFirstName',
                '',
              ),
              [CLAIM.LAST_NAME]: get(
                props.policyInfo,
                'sagis.policy.clientLastName',
                '',
              ),
              [CLAIM.REGISTRATION_NUMBER]: get(
                props.policyInfo,
                'sagis.policy.notStandardizedRegistrationNumber',
                '',
              ),
              [CLAIM.LOSS_DATE]: get(props.policyInfo, [CLAIM.LOSS_DATE]),
              [CLAIM.LOSS_HOUR]: get(
                filterNotRcClaims(props.policyInfo, props.listings),
                `sagis.claims[${props.selectedClaim}].lossTime`,
              ),
              [CLAIM.LOSS_LOCATION]: lossLocationMixedClaim()?.ItemKey,
              [CLAIM.COUNTRY_ID]: lossLocationMixedClaim()?.ItemGroup,
            };
          }
          state.claim = {
            ...EMPTY_CLAIM,
            [CLAIM.CLAIM_NUMBER]: get(
              filterNotRcClaims(props.policyInfo, props.listings),
              `sagis.claims[${props.selectedClaim}].code`,
            ),
            [CLAIM.FIRST_NAME]: get(
              props.policyInfo,
              'sagis.policy.clientFirstName',
              '',
            ),
            [CLAIM.LAST_NAME]: get(
              props.policyInfo,
              'sagis.policy.clientLastName',
              '',
            ),
            [CLAIM.REGISTRATION_NUMBER]: get(
              props.policyInfo,
              'sagis.policy.notStandardizedRegistrationNumber',
              '',
            ),
            [CLAIM.LOSS_DATE]: get(props.policyInfo, [CLAIM.LOSS_DATE]),
            [CLAIM.LOSS_HOUR]: get(
              filterNotRcClaims(props.policyInfo, props.listings),
              `sagis.claims[${props.selectedClaim}].lossTime`,
            ),
            [CLAIM.LOSS_LOCATION]: lossLocationMixedClaim()?.ItemKey,
            [CLAIM.COUNTRY_ID]: lossLocationMixedClaim()?.ItemGroup,
          };
        } else {
          state.claim = {
            ...EMPTY_CLAIM,
            [CLAIM.FIRST_NAME]: get(
              props.policyInfo,
              'sagis.policy.clientFirstName',
              '',
            ),
            [CLAIM.LAST_NAME]: get(
              props.policyInfo,
              'sagis.policy.clientLastName',
              '',
            ),
            [CLAIM.REGISTRATION_NUMBER]: get(
              props.policyInfo,
              'sagis.policy.notStandardizedRegistrationNumber',
              '',
            ),
            [CLAIM.LOSS_DATE]: get(props.policyInfo, [CLAIM.LOSS_DATE]),
            [CLAIM.LOSS_LOCATION]: lossLocationMixedClaim()?.ItemKey,
            [CLAIM.COUNTRY_ID]: lossLocationMixedClaim()?.ItemGroup,
          };
        }
        props.updateFilde && props.updateFilde(state);
      }
    }
  });

  const lossLocationMixedClaim = () => {
    if (props.listings && props.listings.villes)
      return props.listings.villes.find(e =>
        e.ItemDescription.includes(
          get(
            filterNotRcClaims(props.policyInfo, props.listings),
            `sagis.claims[${props.selectedClaim}].lossLocation`,
          ) &&
            get(
              filterNotRcClaims(props.policyInfo, props.listings),
              `sagis.claims[${props.selectedClaim}].lossLocation`,
            ).toUpperCase(),
        ),
      );
    return {} as SagisConfig;
  };

  const handleDateChange = (field: string) => (date: Date | null) => {
    const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
      ? { ...props.storedClaimToPreopen }
      : { ...props.claimToPreopen };

    const { driver } = claimToPreopen;
    const theDate = getDateIgnoreTimezone(date);
    switch (field) {
      case DRIVER.DATE_OF_BIRTH:
        driver[DRIVER.DATE_OF_BIRTH] =
          theDate && moment(theDate as Date).format();
        break;
      case DRIVER.LICENSE_START_DATE:
        driver[DRIVER.LICENSE_START_DATE] =
          theDate && moment(theDate as Date).format();
        break;

      default:
        return claimToPreopen;
    }
    updateClaimDriver({ ...driver });

    props.updateFilde && props.updateFilde(claimToPreopen);
  };

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value: any;
    }>,
  ) => {
    const { value } = event.target;

    const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
      ? { ...props.storedClaimToPreopen }
      : { ...props.claimToPreopen };

    const { driver } = claimToPreopen;

    switch (field) {
      case DRIVER.IS_DRIVER_THE_INSURED:
        driver[DRIVER.IS_DRIVER_THE_INSURED] = value;
        break;
      case DRIVER.LAST_NAME:
        driver[DRIVER.LAST_NAME] = value;
        break;
      case DRIVER.FIRST_NAME:
        driver[DRIVER.FIRST_NAME] = value;
        break;
      case DRIVER.CIN:
        driver[DRIVER.CIN] = value;
        break;
      case DRIVER.SEX:
        driver[DRIVER.SEX] = value;
        break;
      case DRIVER.LICENSE_START_DATE:
        driver[DRIVER.LICENSE_START_DATE] = value;
        break;
      case DRIVER.LICENSE_CATEGORY:
        driver[DRIVER.LICENSE_CATEGORY] = value;
        break;
      case DRIVER.LICENSE_ID:
        driver[DRIVER.LICENSE_ID] = value;
        break;
      case DRIVER.DRIVER_QUALITY:
        driver[DRIVER.DRIVER_QUALITY] = value;
        break;
      default:
        return claimToPreopen;
    }
    updateClaimDriver({ ...driver });
    props.updateFilde && props.updateFilde(claimToPreopen);
  };

  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const getDriverIsInsuredRecapLabel = () => {
    const yes = translate({ ...messages.claimDeclarationYes }, props);
    const no = translate({ ...messages.claimDeclarationNo }, props);
    if (
      props.isManager ||
      (props.isLawyer && isRejected) ||
      props.isCourtManager
    ) {
      return isEmpty(claimDriverToUpdate) ? yes : no;
    }
    return get(claimDriverToUpdate, [DRIVER.IS_DRIVER_THE_INSURED], '') ===
      CHOICE.YES
      ? yes
      : no;
  };

  let value = !isEmpty(props.storedClaimToPreopen)
    ? { ...props.storedClaimToPreopen }
    : props.claimToPreopen;

  const { driver } = value;

  const [claimDriverToUpdate, updateClaimDriver] = useState({ ...driver });

  const [
    expandClaimDeclarationDrawer,
    setExpandClaimDeclarationDrawer,
  ] = React.useState(false);
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const isCourtManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMANAGER,
  );
  const isPreOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISPREOPENMANAGER,
  );

  const updateFormByProfile = (isCancel: boolean = false) => {
    if (
      props.isManager ||
      (props.isLawyer && isRejected) ||
      props.isCourtManager
    ) {
      setExpandClaimDeclarationDrawer(!expandClaimDeclarationDrawer);
      return (
        props.requestClaimRecap &&
        isCancel &&
        props.requestClaimRecap(get(value, 'claim.id'))
      );
    }

    return isOpeningManager
      ? pushTo(PAGES.OPENING_CLAIM)()
      : isCourtManager
      ? pushTo(PAGES.PREOPENING_MANAGER, {
          isFromSagis: true,
          sagisInfoClaim: get(props, 'location.state.sagisInfoClaim'),
        })()
      : isPreOpeningManager
      ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
          isUsageOpening: get(props, 'location.state.isUsageOpening', false),
        })()
      : pushTo(PAGES.PREOPENING)();
  };

  const closeClaimDeclarationDrawer = () => {
    return setExpandClaimDeclarationDrawer(false);
  };

  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    props.claimDeclarationValidation,
    translateArrayErrorMessages(props.claimDeclarationValidation, true),
  );

  const styleWarrantyInfo = {
    marginLeft: '10px',
    padding: '5px 0px',
    fontSize: '20px',
    color: 'red',
  };

  return (
    <Container className="container">
      <Card>
        <CardContent className="cardContent">
          <Title variant="h1" gutterBottom>
            {!props.isManager
              ? translate({ ...messages.claimDeclarationClaimDeclare }, props)
              : translate(
                  { ...messages.claimManagerDeclarationClaimTitle },
                  props,
                )}
          </Title>
          {featureService.hasFeature(FEATURES.DISCLAIMER_WARRANTY) &&
            get(
              props.storedClaimToPreopen,
              'claim.disclaimerWarrantyReasonId',
            ) && (
              <div style={styleWarrantyInfo}>
                {translate({ ...messages.disclaimerWarrantyReason }, props)}
                {getValueByCode(
                  get(
                    props.storedClaimToPreopen,
                    'claim.disclaimerWarrantyReasonId',
                  ),
                  get(props.listings, LISTINGS.DISCLAIMER_WARRANTY_REASONS, []),
                )}
              </div>
            )}
          {shouldDisplayEditButtonClaim(
            props.isRecapPage,
            props.isManager,
            props.isReadOnly,
            value,
            isRejected,
            props.isLawyer,
            props.isCourtManager,
            props.isOpeningManager,
          ) &&
            (isValidated && isOpeningManager
              ? featureService.hasFeature(
                  FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                )
              : true) &&
            (isValidated && props.isCourtManager
              ? featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)
              : true) &&
            !isValidatedCorpo && (
              <SecondaryButton
                variant="contained"
                onClick={() => updateFormByProfile()}
                title={translate({ ...messages.updateBtnLabel }, props)}
              />
            )}
          <div className="subContainer">
            <StyledTextField
              id="standard-basic-c"
              name="policeNumber"
              value={get(props.policyInfo, 'sagis.policy.policyNumber', '')}
              label={translate(
                { ...messages.claimDeclarationPoliceNumber },
                props,
              )}
              className="input"
              InputProps={{ disableUnderline: true }}
              disabled={true}
              InputLabelProps={{
                shrink: props.inputLabelProps,
                classes: { root: 'label-input' },
              }}
            ></StyledTextField>
            <StyledTextField
              id="standard-basic-d"
              name={CLAIM.LAST_NAME}
              value={get(props.policyInfo, 'sagis.policy.clientLastName', '')}
              label={translate({ ...messages.claimDeclarationLastName }, props)}
              className="input"
              InputProps={{ disableUnderline: true }}
              disabled={true}
              InputLabelProps={{
                shrink: props.inputLabelProps,
                classes: { root: 'label-input' },
              }}
            ></StyledTextField>
            <StyledTextField
              id="standard-basic-e"
              name={CLAIM.FIRST_NAME}
              value={get(props.policyInfo, 'sagis.policy.clientFirstName', '')}
              label={translate(
                { ...messages.claimDeclarationFirstName },
                props,
              )}
              className="input"
              InputProps={{ disableUnderline: true }}
              disabled={true}
              InputLabelProps={{ shrink: props.inputLabelProps }}
            ></StyledTextField>
            <StyledTextField
              id="standard-basic-f"
              name="CIN"
              value={get(props.policyInfo, 'sagis.policy.CIN', '')}
              label={translate(
                { ...messages.claimDeclarationCINNumber },
                props,
              )}
              className="input"
              InputProps={{ disableUnderline: true }}
              disabled={true}
              InputLabelProps={{
                shrink: props.inputLabelProps,
                classes: { root: 'label-input' },
              }}
            />
          </div>
          <div className="subContainer">
            <StyledTextField
              id="standard-basic-g"
              name={CLAIM.REGISTRATION_NUMBER}
              value={get(
                props.policyInfo,
                'sagis.policy.notStandardizedRegistrationNumber',
                '',
              )}
              label={translate(
                { ...messages.claimDeclarationRegistrationNumber },
                props,
              )}
              className="input"
              InputProps={{ disableUnderline: true }}
              disabled={true}
              InputLabelProps={{
                shrink: props.inputLabelProps,
                classes: { root: 'label-input' },
              }}
            />
            <StyledTextField
              id="standard-basic-h"
              name="VehicleCategory"
              value={get(props.policyInfo, 'sagis.policy.vehicleUse', '')}
              label={translate(
                { ...messages.claimDeclarationVehicleCategory },
                props,
              )}
              className="input"
              InputProps={{ disableUnderline: true }}
              disabled={true}
              InputLabelProps={{
                shrink: props.inputLabelProps,
                classes: { root: 'label-input' },
              }}
            />
            <StyledTextField
              id="date-picker-inline-policy-start-date"
              name="startDate"
              value={get(
                props.policyInfo,
                ['sagis', 'policy', 'startDate'],
                '',
              )}
              label={translate(
                { ...messages.claimDeclarationEffectiveDate },
                props,
              )}
              className="input"
              InputProps={{ disableUnderline: true }}
              disabled={true}
              InputLabelProps={{
                shrink: props.inputLabelProps,
                classes: { root: 'label-input' },
              }}
            />
            <StyledTextField
              id="date-picker-inline-policy-end-date"
              name="endDate"
              value={get(props.policyInfo, ['sagis', 'policy', 'endDate'], '')}
              label={translate({ ...messages.claimDeclarationDueDate }, props)}
              className="input"
              InputProps={{ disableUnderline: true }}
              disabled={true}
              InputLabelProps={{
                shrink: props.inputLabelProps,
                classes: { root: 'label-input' },
              }}
            />
          </div>
          <div className="checkdiv">
            <Typography className="text">
              {translate(
                { ...messages.claimDeclarationDriverPolicyholder },
                props,
              )}
            </Typography>
            {!props.isRecapPage ? (
              <FormControl>
                <RadioGroup
                  row
                  value={get(driver, [DRIVER.IS_DRIVER_THE_INSURED], '')}
                  onChange={handleChange(DRIVER.IS_DRIVER_THE_INSURED)}
                >
                  <FormControlLabel
                    control={
                      <Radio
                        value={CHOICE.YES}
                        color="primary"
                        checkedIcon={<CheckCircle />}
                      />
                    }
                    label={translate(
                      { ...messages.claimDeclarationYes },
                      props,
                    )}
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.NO}
                        checkedIcon={<CheckCircle />}
                      />
                    }
                    label={translate({ ...messages.claimDeclarationNo }, props)}
                  />
                </RadioGroup>
                {!!get(props.claimDeclarationValidation, [
                  DRIVER.IS_DRIVER_THE_INSURED,
                ]) && (
                  <FormHelperText className="error">
                    {message[DRIVER.IS_DRIVER_THE_INSURED]}
                  </FormHelperText>
                )}
              </FormControl>
            ) : (
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={true}
                    checkedIcon={<CheckCircle />}
                    icon={<RadioButtonUnchecked />}
                    disabled={props.disableInput}
                  />
                }
                label={getDriverIsInsuredRecapLabel()}
              />
            )}
          </div>
          <Collapse
            in={
              props.isOnlyForRead
                ? !isEmpty(driver)
                : props.isRecapPage &&
                  (props.isManager ||
                    (props.isLawyer && isRejected) ||
                    props.isCourtManager)
                ? !isEmpty(claimDriverToUpdate)
                : get(driver, [DRIVER.IS_DRIVER_THE_INSURED], '') === CHOICE.NO
            }
            timeout="auto"
            unmountOnExit
          >
            <div className="subContainer">
              <StyledTextField
                id="standard-basic-n"
                name={DRIVER.LAST_NAME}
                value={get(claimDriverToUpdate, [DRIVER.LAST_NAME])}
                onChange={handleChange(DRIVER.LAST_NAME)}
                label={translate(
                  { ...messages.claimDeclarationLastName },
                  props,
                )}
                className="input"
                InputProps={props.inputProps}
                disabled={props.disableInput}
                InputLabelProps={{
                  shrink: props.inputLabelProps,
                  classes: { root: 'label-input' },
                }}
                error={
                  !!get(props.claimDeclarationValidation, [DRIVER.LAST_NAME])
                }
                helperText={message[DRIVER.LAST_NAME]}
              ></StyledTextField>
              <StyledTextField
                id="standard-basic-v"
                name={DRIVER.FIRST_NAME}
                value={get(claimDriverToUpdate, [DRIVER.FIRST_NAME])}
                onChange={handleChange(DRIVER.FIRST_NAME)}
                label={translate(
                  { ...messages.claimDeclarationFirstName },
                  props,
                )}
                className="input"
                InputProps={props.inputProps}
                disabled={props.disableInput}
                InputLabelProps={{
                  shrink: props.inputLabelProps,
                  classes: { root: 'label-input' },
                }}
                error={
                  !!get(props.claimDeclarationValidation, [DRIVER.FIRST_NAME])
                }
                helperText={message[DRIVER.FIRST_NAME]}
              ></StyledTextField>
              <StyledTextField
                id="standard-basic-o"
                name={DRIVER.CIN}
                value={get(claimDriverToUpdate, [DRIVER.CIN])}
                onChange={handleChange(DRIVER.CIN)}
                label={translate(
                  { ...messages.claimDeclarationCINNumber },
                  props,
                )}
                className="input"
                InputProps={props.inputProps}
                disabled={props.disableInput}
                InputLabelProps={{
                  shrink: props.inputLabelProps,
                  classes: { root: 'label-input' },
                }}
                error={!!get(props.claimDeclarationValidation, [DRIVER.CIN])}
                helperText={message[DRIVER.CIN]}
              ></StyledTextField>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  invalidDateMessage={
                    !!get(props.claimDeclarationValidation, [
                      DRIVER.DATE_OF_BIRTH,
                    ])
                      ? message[DRIVER.DATE_OF_BIRTH]
                      : get(claimDriverToUpdate, [DRIVER.DATE_OF_BIRTH], '') ===
                        'Invalid date'
                      ? translate({ ...messages.invalidDate }, props)
                      : ''
                  }
                  format="dd/MM/yyyy"
                  id="date-picker-inline-driver-date-of-birth"
                  name={DRIVER.DATE_OF_BIRTH}
                  value={dateStringToLocalDate(
                    get(claimDriverToUpdate, [DRIVER.DATE_OF_BIRTH], ''),
                  )}
                  onChange={handleDateChange(DRIVER.DATE_OF_BIRTH)}
                  label={translate(
                    { ...messages.claimDeclarationBirthDate },
                    props,
                  )}
                  className="input"
                  InputProps={props.inputProps}
                  disabled={props.disableInput}
                  InputLabelProps={{
                    shrink:
                      props.inputLabelProps ||
                      !!get(driver, [DRIVER.DATE_OF_BIRTH], ''),
                    classes: { root: 'label-input' },
                  }}
                  error={
                    get(claimDriverToUpdate, [DRIVER.DATE_OF_BIRTH], '') ===
                    'Invalid date'
                  }
                  helperText={
                    get(claimDriverToUpdate, [DRIVER.DATE_OF_BIRTH], '') ===
                      'Invalid date' &&
                    translate({ ...messages.invalidDate }, props)
                  }
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="subContainer">
              <FormControl
                className="input"
                error={!!get(props.claimDeclarationValidation, [DRIVER.SEX])}
              >
                <InputLabel
                  ref={inputLabel}
                  id="demo-simple-select-outlined-label"
                >
                  {translate({ ...messages.claimDeclarationGender }, props)}
                </InputLabel>
                <Select
                  name={DRIVER.SEX}
                  value={get(claimDriverToUpdate, [DRIVER.SEX], '')}
                  onChange={handleChange(DRIVER.SEX)}
                  labelWidth={60}
                  disabled={props.disableInput}
                >
                  <MenuItem value={10}>HOMME</MenuItem>
                  <MenuItem value={20}>FEMME</MenuItem>
                </Select>
                {!!get(props.claimDeclarationValidation, [DRIVER.SEX]) && (
                  <FormHelperText className="errorSelect">
                    {message[DRIVER.SEX]}
                  </FormHelperText>
                )}
              </FormControl>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  variant="inline"
                  autoOk
                  invalidDateMessage={
                    (!!get(props.claimDeclarationValidation, [
                      DRIVER.LICENSE_START_DATE,
                    ]) &&
                      message[DRIVER.LICENSE_START_DATE]) ||
                    (get(
                      claimDriverToUpdate,
                      [DRIVER.LICENSE_START_DATE],
                      '',
                    ) === 'Invalid date' &&
                      translate({ ...messages.invalidDate }, props))
                  }
                  format="dd/MM/yyyy"
                  id="date-picker-inline-driver-license-start-date"
                  name={DRIVER.LICENSE_START_DATE}
                  value={dateStringToLocalDate(
                    get(claimDriverToUpdate, [DRIVER.LICENSE_START_DATE]),
                  )}
                  onChange={handleDateChange(DRIVER.LICENSE_START_DATE)}
                  label={translate(
                    { ...messages.claimDeclarationLicenseDate },
                    props,
                  )}
                  className="input"
                  InputProps={props.inputProps}
                  disabled={props.disableInput}
                  InputLabelProps={{
                    shrink:
                      props.inputLabelProps ||
                      !!get(driver, [DRIVER.LICENSE_START_DATE]),
                    classes: { root: 'label-input' },
                  }}
                  error={
                    get(
                      claimDriverToUpdate,
                      [DRIVER.LICENSE_START_DATE],
                      '',
                    ) === 'Invalid date'
                  }
                  helperText={
                    get(
                      claimDriverToUpdate,
                      [DRIVER.LICENSE_START_DATE],
                      '',
                    ) === 'Invalid date' &&
                    translate({ ...messages.invalidDate }, props)
                  }
                />
              </MuiPickersUtilsProvider>
              <FormControl
                className="input"
                error={
                  !!get(props.claimDeclarationValidation, [
                    DRIVER.LICENSE_CATEGORY,
                  ])
                }
              >
                <InputLabel
                  ref={inputLabel}
                  id="demo-simple-select-outlined-label"
                >
                  {translate(
                    { ...messages.claimDeclarationLicenseCategory },
                    props,
                  )}
                </InputLabel>
                <Select
                  name={DRIVER.LICENSE_CATEGORY}
                  value={get(claimDriverToUpdate, [DRIVER.LICENSE_CATEGORY])}
                  onChange={handleChange(DRIVER.LICENSE_CATEGORY)}
                  labelWidth={150}
                  disabled={props.disableInput}
                >
                  {!isEmpty(
                    get(props.listings, 'drivingLicenseCategories', []),
                  ) &&
                    props.listings!.drivingLicenseCategories.map(category => (
                      <MenuItem value={category.id} key={category.id}>
                        {category.title}
                      </MenuItem>
                    ))}
                </Select>
                {!!get(props.claimDeclarationValidation, [
                  DRIVER.LICENSE_CATEGORY,
                ]) && (
                  <FormHelperText className="errorSelect">
                    {message[DRIVER.LICENSE_CATEGORY]}
                  </FormHelperText>
                )}
              </FormControl>
              <StyledTextField
                id="standard-basic-zz"
                name={DRIVER.LICENSE_ID}
                value={get(claimDriverToUpdate, [DRIVER.LICENSE_ID])}
                onChange={handleChange(DRIVER.LICENSE_ID)}
                label={translate(
                  { ...messages.claimDeclarationLicenseNumber },
                  props,
                )}
                className="input"
                InputProps={props.inputProps}
                disabled={props.disableInput}
                InputLabelProps={{
                  shrink: props.inputLabelProps,
                  classes: { root: 'label-input' },
                }}
                error={
                  !!get(props.claimDeclarationValidation, [DRIVER.LICENSE_ID])
                }
                helperText={message[DRIVER.LICENSE_ID]}
              />
            </div>
            <div className="subContainerSP">
              <FormControl
                className="input"
                error={
                  !!get(props.claimDeclarationValidation, [
                    DRIVER.DRIVER_QUALITY,
                  ])
                }
              >
                <InputLabel
                  ref={inputLabel}
                  id="demo-simple-select-outlined-label"
                >
                  {translate({ ...messages.driverQuality }, props)}
                </InputLabel>
                <Select
                  name={DRIVER.DRIVER_QUALITY}
                  value={get(claimDriverToUpdate, [DRIVER.DRIVER_QUALITY])}
                  onChange={handleChange(DRIVER.DRIVER_QUALITY)}
                  labelWidth={150}
                  disabled={props.disableInput}
                >
                  {!isEmpty(get(props.listings, 'driverQuality', [])) &&
                    props.listings!.driverQuality.map(quality => (
                      <MenuItem value={quality.id} key={quality.id}>
                        {quality.title}
                      </MenuItem>
                    ))}
                </Select>
                {!!get(props.claimDeclarationValidation, [
                  DRIVER.DRIVER_QUALITY,
                ]) && (
                  <FormHelperText className="errorSelect">
                    {message[DRIVER.DRIVER_QUALITY]}
                  </FormHelperText>
                )}
              </FormControl>
            </div>
          </Collapse>
        </CardContent>
      </Card>
      <ClaimDeclarationDrawer
        open={expandClaimDeclarationDrawer}
        handleToggleDrawer={updateFormByProfile}
        listings={props.listings}
        data={value}
        setClaimRecap={props.setClaimRecap}
        closeClaimDeclarationDrawer={closeClaimDeclarationDrawer}
        claimDriverToUpdate={claimDriverToUpdate}
        updateClaimDriver={updateClaimDriver}
        setDataClaimToUpdate={props.setDataClaimToUpdate}
        dataClaimToUpdate={props.dataClaimToUpdate}
      />
    </Container>
  );
};
export default injectIntl(ClaimInformation);
